import { Component } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-community';
import { Session } from '../../../shared/models/session.model';
import { AuthUser, Role } from '../../../shared/models/user.model';
import { SessionsService } from '../../../shared/services/sessions.service';
import { UsersService } from '../../../shared/services/users.service';

@Component({
  standalone: false,
  selector: 'app-session-actions',
  templateUrl: './session-actions.component.html',
  styleUrls: ['./session-actions.component.scss'],
})
export class SessionActionsComponent {
  currentRow: Session;
  currentUser: AuthUser;

  constructor(
    private sessionService: SessionsService,
    private userService: UsersService
  ) {}

  agInit(params: ICellRendererParams): void {
    this.currentRow = params.data;
    this.currentUser = this.userService.authUser;
  }

  refresh(params: ICellRendererParams) {
    return true;
  }

  onClick(clickedItem: string) {
    this.sessionService.announceAction({ name: clickedItem, row: this.currentRow, column: 'action' });
  }

  canShowActionDump() {
    return this.currentUser.role === Role.ADMIN;
  }

  protected readonly Role = Role;
}
